
import {Prop} from "vue-property-decorator"
import Vue from "vue"
import Component from "vue-class-component"
import {getArrow} from "@/ui/chartTheme"
import AnimatedNumber from "@/ui/AnimatedNumber.vue"

@Component({
  components: {AnimatedNumber},
})
export default class ChangeRateWidget extends Vue {
  @Prop({required: true})
  value: number | undefined

  @Prop({required: true})
  unit: "pp" | "%"

  @Prop({default: false})
  isDownPositive: boolean

  unitDescription: string

  async created() {
    this.unitDescription = this.unit === "pp" ? "Percentage points" : ""
  }

  get arrow() {
    return getArrow(this.value!, this.isDownPositive)
  }

  get normalizedRate() {
    if (this.value === Infinity) {
      return {value: "∞", unit: ""}
    } else {
      const value = Math.abs(this.value!)

      return {value, unit: this.unit}
    }
  }

  get isReady() {
    return this.value != null && !Number.isNaN(this.value)
  }
}
